import { render, staticRenderFns } from "./tipodeconvenio.vue?vue&type=template&id=08160365"
import script from "./tipodeconvenio.vue?vue&type=script&lang=js"
export * from "./tipodeconvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports